import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IFocusCell } from "../../../components-ui/data-table/DataTable";
import { IMucThuKhacSinhVienSaveHocPhiTinChiRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveHocPhiTinChiRequest";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { IMucThuTinChiDuyetLopTuNguyenRequest } from "../../../model/request/chung-tu/IMucThuTinChiDuyetLopTuNguyenRequest";
import { IMucThuTinChiGanMucThuRequest } from "../../../model/request/chung-tu/IMucThuTinChiGanMucThuRequest";
import { IDanhSachLopTinChiSelectByLopTcRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectByLopTcRequest";
import { IDanhSachLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import { ILopTuNguyenSelectRequest } from "../../../model/request/lop-tin-chi/ILopTuNguyenSelectRequest";
import { ISinhVienSelectByKyDangKyRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByKyDangKyRequest";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IMucThuKhacSinhVien } from "../../../model/respone/chung-tu/IMucThuKhacSinhVien";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { IDanhSachLopTinChiViewModel } from "../../../model/respone/lop-tin-chi/IDanhSachLopTinChiViewModel";
import { IPlanLopTinChiTcTreeVm } from "../../../model/respone/lop-tin-chi/IPlanLopTinChiTcTreeVm";
import { ISinhVienLopTinChiSoTienCalculateRespone } from "../../../model/respone/lop-tin-chi/ISinhVienLopTinChiSoTienCalculateRespone";
import { IMucThuTinChiCalculate } from "../../reducer-model/muc-thu/IMucThuTinChiReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMucThuTinChiActionsObj = {
  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_LOAI_THU_CHI: 0,
  CHANGE_KY_DANG_KY: 0,
  CHANGE_TRANG_THAI_HOC: [] as number[],
  CHANGE_DOI_TUONG: [] as number[],
  CHANGE_TRANG_TONG_HOP: "",
  CHANGE_TINH_CHAT_HOC: 0,

  LOAD_HOCSINH_START: {} as ISinhVienSelectByLopsRequest,
  LOAD_HOCSINH_SUCCESS: {} as IStuHoSoSinhVienViewModel[],
  LOAD_HOCSINH_ERRR: "",

  CALCULATE_START: {} as IDanhSachLopTinChiSelectRequest,
  CALCULATE_SUCCESS: {} as ISinhVienLopTinChiSoTienCalculateRespone,
  CALCULATE_ERRR: "",

  UPDATE_CALCULATE_STATE: {} as IMucThuTinChiCalculate,

  SAVE_CALCULATE_START: {} as IMucThuKhacSinhVienSaveHocPhiTinChiRequest,
  SAVE_CALCULATE_SUCCESS: undefined,
  SAVE_CALCULATE_ERRR: "",

  LOAD_MUCTHUKHAC_START: {} as IMucThuKhacSinhVienSelectByLopsRequest,
  LOAD_MUCTHUKHAC_SUCCESS: {} as IMucThuKhacSinhVienViewModel[],
  LOAD_MUCTHUKHAC_ERRR: "",

  SHOWHIDE_VIEW_LOPTINCHIS: {} as any[] | undefined,

  /** Ô lọc "Trạng thái" của tab Rút / hủy học phần. */
  CHANGE_LOC_TRANG_THAI_RUT: "",

  CHANGE_TAB_PAGE: {} as
    | "all"
    | "bo-sung"
    | "rut"
    | "theo-sinh-vien"
    | "lop-tu-nguyen"
    | "theo-lop-tin-chi"
    | "hoc-phan-mien"
    | "hoc-bu"
    | "thi-lai"
    | "hoc-lai-cai-thien"
    | "qua-han"
    | "ra-soat"
    | "khoa-dung-khoa",

  // ===== Lớp tự nguyện (LTN) =====
  LOAD_LTN_TREE_START: {} as ILopTuNguyenSelectRequest,
  LOAD_LTN_TREE_SUCCESS: [] as IPlanLopTinChiTcTreeVm[],
  LOAD_LTN_TREE_ERRR: "",

  SELECT_LTN_LOP_TC: {} as IDanhSachLopTinChiSelectByLopTcRequest | undefined,

  LOAD_LTN_SINHVIEN_START: {} as IDanhSachLopTinChiSelectByLopTcRequest,
  LOAD_LTN_SINHVIEN_SUCCESS: [] as IDanhSachLopTinChiViewModel[],
  LOAD_LTN_SINHVIEN_ERRR: "",

  LTN_SELECT_SV_IDS: [] as string[],
  LTN_CHANGE_FOCUSED_CELL: {} as IFocusCell,
  LTN_SHOWHIDE_GAN_MODAL: false,

  GAN_MUC_THU_START: {} as IMucThuTinChiGanMucThuRequest,
  GAN_MUC_THU_SUCCESS: undefined,
  GAN_MUC_THU_ERRR: "",

  DUYET_LTN_START: {} as IMucThuTinChiDuyetLopTuNguyenRequest,
  DUYET_LTN_SUCCESS: undefined,
  DUYET_LTN_ERRR: "",

  HUYDUYET_LTN_START: {} as IMucThuTinChiDuyetLopTuNguyenRequest,
  HUYDUYET_LTN_SUCCESS: undefined,
  HUYDUYET_LTN_ERRR: "",

  LTN_CLOSE_PROCESSING_MODAL: undefined,
};
export const eMucThuTinChiActionIds = generateActionTypeIds(
  eMucThuTinChiActionsObj,
  "MUC_THU_TIN_CHI",
);
export type IMucThuTinChiActionTypes = IGenericActionType<
  typeof eMucThuTinChiActionsObj,
  "MUC_THU_TIN_CHI"
>;
